import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Modal } from '@/components/Modal';

export const ButtonWrapper = styled.div<{ $isAvailable?: boolean }>`
  width: 100%;
  ${({ $isAvailable, theme }) => css`
    margin-bottom: ${theme.spacing(2)};
    display: ${$isAvailable ? 'inline-block' : 'none'};
  `}

  & apple-pay-button {
    --apple-pay-button-width: 100%;
    --apple-pay-button-height: 48px;
    width: 100%;
    height: 48px;
  }
`;

export const ModalWrapper = styled(Modal)`
  padding: 0;
  height: auto;

  ${({ theme }) =>
    css`
      ${theme.media.sm.down} {
        bottom: 0;
        position: absolute;
        align-items: flex-start;
      }
    `}
`;

export const ModalHeader = styled(Flex)`
  height: 54px;
`;

export const ModalBody = styled(Flex)`
  ${({ theme }) =>
    css`
      padding: ${theme.spacing(4, 2, 0, 2)};

      ${theme.media.sm.up} {
        padding: ${theme.spacing(4, 4, 0, 4)};
      }
    `}
`;

export const ModalFooter = styled(Flex)`
  flex-direction: column;

  & > button {
    flex: 1;
  }

  ${({ theme }) =>
    css`
      padding: ${theme.spacing(4, 2)};

      ${theme.media.sm.up} {
        flex-direction: row-reverse;
        padding: ${theme.spacing(3, 4)};
      }
    `}
`;
